/**
 * Button
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Button as ButtonBase } from 'ui-component-library/base';
var Button = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'button' : _b, onFieldChange = _a.onFieldChange, resetForm = _a.resetForm, showError = _a.showError, visibleFields = _a.visibleFields, children = _a.children, propsToTransfer = __rest(_a, ["type", "onFieldChange", "resetForm", "showError", "visibleFields", "children"]);
    if (type === 'reset') {
        return (React.createElement(ButtonBase, __assign({ type: type, variant: "secondary" }, propsToTransfer, { onClick: resetForm }), children));
    }
    else {
        return (React.createElement(ButtonBase, __assign({ type: type }, propsToTransfer), children));
    }
};
export default Button;
